import { CatalogOutputRow } from '../types';
import { detectExcelFormat } from './detect-excel-format.util';
import {
    getShamirRXParsedRowData,
    getShamirSTParsedRowData,
    parseShamirRXExcel,
    parseShamirSTExcel,
} from './parse-shamir-data';

export const parseExcelCatalog = (file: ArrayBuffer): CatalogOutputRow[] => {
    const format = detectExcelFormat(file);

    if (format === 'shamir-rx') {
        return parseShamirRXExcel(file).map((row) => getShamirRXParsedRowData(row));
    }

    return parseShamirSTExcel(file).map((row) => getShamirSTParsedRowData(row));
};
